import { AuditDocumentTypes, AuditActionTypeConstant, Constants } from "./keyConstants";
import { getMasterDocDataByKey } from "./ReduxUtils";
import { generateAuditObj, getItem } from "./utils";

const userData = getItem(Constants.KEY_USER_DATA);
const selectedRole = getItem(Constants.KEY_SELECTED_ROLE);

/**
 * Middleware service to build audit object consistently.
 *
 * @param {Object} params
 * @param {Object} params.data - Document/master data
 * @param {string} params.action - Audit action type
 * @param {string} params.locationPath - Path of action (customizable)
 * @returns {Object} auditObj
 */
export const createAuditLog = ({ data, action, locationPath }) => {
    const defaultMasterDocData = getMasterDocDataByKey({
        masterDocId: data?.masterDocId,
    });

    return generateAuditObj?.({
        documentId: data?.documentId ?? data?._id ?? null,
        changedFields: data?.changedFields ?? [],
        documentType: data?.documentType ?? AuditDocumentTypes?.Record,
        documentName: data?.masterDocName ?? defaultMasterDocData?.name ?? "",
        action: action ?? AuditActionTypeConstant?.Prepare,
        actionMessage: `${userData?.name} - ${selectedRole?.roleName} ${action ?? AuditActionTypeConstant?.Prepare} ${defaultMasterDocData?.name ?? data?.masterDocName}`,
        masterDocId: data?.masterDocId ?? null,
        locationPath: locationPath ?? `/dashboard`,
    });
};


export const createReadAuditLog = async ({ data, action, locationPath, documentId }) => {
    const defaultMasterDocData = getMasterDocDataByKey({
        masterDocId: data?.masterDocId,
    });
    await createReadLog({
        masterDocData: {
            name: defaultMasterDocData?.name,
            _id: defaultMasterDocData?.masterDocId,
        },
        documentType: action ?? AuditDocumentTypes?.Record,
        locationPath: locationPath,
        documentId: documentId ?? data?._id ?? null,
    });
}